import React from 'react'
import { useTranslation } from 'react-i18next'
import CenteredContent from './CenteredContent'
import { PublicOff as PublicOffIcon } from '@mui/icons-material'
import { Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'

const Error403Page = () => {
  const { t } = useTranslation()

  return (
    <CenteredContent sx={{ marginX: 3 }}>
      <PublicOffIcon fontSize="large" sx={{ marginRight: 3 }} />
      <Typography variant="h6">
        {t('errors.error403')}
        <Box sx={{ textAlign: 'center', marginTop: 1 }}>
          <Link to="/">{t('app.homeButton')}</Link>
        </Box>
      </Typography>
    </CenteredContent>
  )
}

export default Error403Page
